export default function calcularPercentualBarra(valor, maiorValor) {
  if (!maiorValor) return 0;

  return Math.max(8, Math.round((valor / maiorValor) * 100));
}
